export default {
    API_ENDPOINT: 'https://aqueous-falls-36784.herokuapp.com',
    EVENT_API:'https://api.seatgeek.com/2/events',
    EVENT_API_KEY: 'MTY5MDU0NDV8MTU2MzgzODkyMy4xNw',
    TOKEN_KEY: 'this-week-client-auth-token',
}